import {useEffect, useState} from "react";
import {Button} from "../common/Button";
import {useFunnelNavigation} from "../../hooks/useFunnelNavigation";

export function Welcome() {
    const {nextStep} = useFunnelNavigation();
    const [loading, setLoading] = useState(true);
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const loadingTimer = setTimeout(() => {
            setLoading(false);
            const buttonTimer = setTimeout(() => {
                setShowButton(true);
            }, 300);

            return () => clearTimeout(buttonTimer);
        }, 2000);

        return () => clearTimeout(loadingTimer);
    }, []);

    return (
        <div className="flex flex-col bg-[#192B2D] min-h-screen">
            {/* Background Image */}
            <div className=" inset-0 z-0">
                <img
                    src="/w-start.webp"
                    alt="Background"
                    className="w-full h-full object-cover"
                />
            </div>

            {/* Logo and App Name */}
            <div className="absolute inset-0 z-10 p-4">
                <div className="flex items-center justify-center space-x-2">
                    <img src="/app_icon.png" alt="Caloria Logo" className="w-10 h-10"/>
                    <span className="text-2xl font-bold text-white">Caloria</span>
                </div>
            </div>

            {/* Bottom Content Section */}
            <div className="fixed bottom-0  z-10 p-4 space-y-6 max-w-[420px]">
                {/* Text Content */}
                <div className="text-center space-y-2">
                    <h1 className="text-4xl font-bold text-gray-100">Healthy eating.</h1>
                    <h2 className="text-3xl font-bold text-gray-100">Simplified.</h2>
                    <p className="text-sm text-gray-300 px-12">
                        Let's begin with a few questions to create your personalized plan!
                    </p>
                </div>

                {/* Button Section */}
                <div className="w-full max-w-[320px] mx-auto">
                    <div className="h-[52px] w-full flex flex-col items-center justify-center">
                        {loading ? (
                            <>
                                <div className="w-full bg-white/20 rounded-full h-2 overflow-hidden">
                                    <div
                                        className="h-full bg-green-500 rounded-full transition-all duration-200 ease-out"
                                        style={{
                                            width: "100%",
                                            animation: "progressAnimation 2s linear",
                                        }}
                                    />
                                </div>
                                <div className="text-white text-sm">
                                    <span className="loading-percentage"></span>
                                </div>
                            </>
                        ) : (
                            <Button
                                color="white"
                                onClick={nextStep}
                                className={`w-full text-black transition-opacity duration-300 ${
                                    showButton ? "opacity-100" : "opacity-0"
                                }`}
                            >
                                Start the Quiz
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
